import React from "react"
import { navigate } from "gatsby"

const MobileSecure = ({ component: Component, location, ...rest }) => {
  const validation =
    typeof window !== `undefined`
      ? localStorage.getItem("mobile_token")
      : null

  if (
    validation === null &&
      typeof window !== `undefined`
  ) {
    navigate("/business-support/")
    return null
  }

  return <Component {...rest} />
}

export default MobileSecure
